import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../assets/css/webphone.css'
import person from '../assets/images/person.svg'
import Comtemplete from '../pages/comtemplete';
import { FetchDispo, Hangup } from '../redux/apicalling/dispatchfunction';
import { CrmUrl } from '../redux/apicalling/dispatchfunction';
import { setcallstatus } from '../redux/callstatus/callstatusaction';
import { rtcended, setshowcalllogpage } from '../redux/backgroundpermission/permission-action';
import {
    faEye,
    faPlus,
    faMicrophone,
    faMicrophoneSlash,
    faPhoneSlash,
    faPhone,
    faPause,
    faPlay,
    faKeyboard,
    faUsers,
    faShareSquare,
    faUserAstronaut,
    faPersonWalkingDashedLineArrowRight,

} from '@fortawesome/free-solid-svg-icons';

function formatCallDuration(durationInSeconds) {
    const minutes = Math.floor(durationInSeconds / 60).toString().padStart(2, '0');
    const seconds = (durationInSeconds % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
}

function Webphone() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const session = useSelector((state) => state.session);
    const caller_insight = useSelector((state) => state.callerinsight);
    const backgroundstate = useSelector((state) => state.bgpermission)
    const [isMuted, setIsMuted] = useState(false);
    const [callStatus, setCallStatus] = useState('oncall');
    const [isOnHold, setIsOnHold] = useState(false);
    const [callDuration, setCallDuration] = useState(0);
    const [callended, setCallended] = useState(true)
    const [callStartTime, setCallStartTime] = useState(null);
    const [ticektname, setTicketName] = useState('');
    const [phonenumber, setPhoneNumber] = useState('')
    const [showdispopage, setDispopage] = useState(false)
    const agent_name = localStorage.getItem('username')


    const config_api = JSON.parse(localStorage.getItem('config'))
     const numberMask = JSON.parse(localStorage.getItem('number_mask'));
     const userPermission = config_api.projects[0].userPermission;
    const headers = session._request.headers;
    let profile_id = headers['Profile-Id']?.[0]?.raw;
    let call_token = headers['Call-Token']?.[0]?.raw;
    let agent_id = headers['Agent-Id']?.[0]?.raw;
    const getconfigdata = localStorage.getItem('config')
    const getconfig = JSON.parse(getconfigdata)
    let user_id = getconfig.projects[0].userInfo[0].user_id
    const [dispositionStatusOptions, setDispositionStatusOptions] = useState("")
    const [callNotes, setCallNotes] = useState('');
    const [dispositionStatus, setDispositionStatus] = useState('');
    const [entity_id, setEntityId] = useState("")
    const [entity_type, setEntityType] = useState("")

 useEffect(() => {
    if (caller_insight !== null && caller_insight !== undefined) {
        setTicketName(caller_insight.ticket_name || ticektname || "UNKNOWN NAME")

        if (caller_insight?.ticket_number) {
            setPhoneNumber(caller_insight.ticket_number)
        }

        let caller_info = {
            phone_number: caller_insight?.ticket_number || phonenumber,
            id: caller_insight?.lead_id,
            profile_id: profile_id,
            call_token: call_token,
            agent_id: agent_id,
        }
        localStorage.setItem('callerinfo', JSON.stringify(caller_info))
    } else {
        setTicketName("UNKNOWN NAME")
        setPhoneNumber("1234")
    }
}, [caller_insight])

    // useEffect(() => {

    //     fetchDispo();
    // }, [])


    const startCallDuration = () => {
        if (!callStartTime) {
            setCallStartTime(new Date());
        }
    };
    const resetCallDuration = () => {
        setCallStartTime(null);
        setCallDuration(0);
    };
    const fetchDispo = async () => {
        dispatch(FetchDispo())
            .then((response) => {
                if (response.status === 200) {
                    const extractedStatuses = response.data.data;
                    let dispoobjdecode = Object.values(extractedStatuses)

                    const dispoarraydecode = dispoobjdecode.map((dispo, index) => {

                        // let dipostatus =dispo[0]
                        // dispatch(setcallstatus(dipostatus))
                        return dispo[0]


                    });


                    dispatch(setcallstatus(dispoarraydecode))

                }

            })
            .catch((err) => {
                return err

            });


    }

    const crmviewlead = () => {
        console.log("Test");



    };


    useEffect(() => {
        startCallDuration()
        setCallended(true)
    }, [backgroundstate.rtcprocess]);

    useEffect(() => {
        if (callStartTime) {
            const timer = setInterval(() => {
                const currentTime = new Date();
                const durationInSeconds = Math.floor((currentTime - callStartTime) / 1000);
                setCallDuration(durationInSeconds);
            }, 1000);

            return () => {
                clearInterval(timer);
            };
        }

    }, [callStartTime]);


    const toggleMute = () => {
        setIsMuted(!isMuted);
        if (session) {
            if (isMuted) {
                session.unmute();
                setCallStatus('oncall');
            } else {
                session.mute();
                setCallStatus('mute');
            }
        }
    };


    const toggleHold = () => {
        setIsOnHold(!isOnHold);

        if (session) {
            if (isOnHold) {
                session.unhold();
                setCallStatus('oncall');
            } else {
                session.hold();
                setCallStatus('hold');
            }
        }
    };

    const viewlead = () => {
        console.log("Testing Lead");
        //    window.open(`https://b24-95cl1o.bitrix24.in/crm/deal/details/6/`, '_blank');


    };
    const handleHangup = () => {

        try {
        const payload = {
            "station": getconfig.projects[0].userInfo[0].user_phone_number,
            "phone_number": caller_insight?.ticket_number,
            "tenant_id": getconfig.projects[0].userInfo[0].tenant_code,
            "entity_type": entity_type,
            "user_id":getconfig.projects[0].userInfo[0].user_id,
            "entity_id": entity_id,
            "agent": { "identity": "user", "value": getconfig.projects[0].userInfo[0].user_email },
            "call_status": dispositionStatus,
            "description": callNotes,
            "profile_id": profile_id,
            "call_token": call_token,
            "agent_id": agent_id,
        }

            dispatch(Hangup(payload))
                .then((response) => {
                    console.log(payload,caller_insight,"Hangup============>", response);
                    if (response.status === 200) {
                        console.log('callerinfocallerinfocallerinfo',response)
                        session.terminate();
                        localStorage.setItem('livecall', false)
                        localStorage.removeItem('callerinfo')
                        dispatch(setshowcalllogpage(true))
                        dispatch(rtcended(false))


                        setCallStatus('ended');





                    }

                })
                .catch((err) => {
                    console.log("errrrrrrrrr", err);
                });




        } catch (error) {
            return error
        }



    };
 const maskPhoneNumber = (phoneNumber) => {
      if (!phoneNumber) return phoneNumber;
    const maskedNumber = phoneNumber.slice(0, -4).padEnd(phoneNumber.length, 'X');
    return maskedNumber;
  };

    return (

        <div>


            <div className='webphone-top-container'>
                <div className="call-duration-status">
                    {formatCallDuration(callDuration)}

                    <div >

                        {callStatus === 'oncall' && <span>On Call</span>}
                        {callStatus === 'ended' && <span>Call Ended</span>}
                        {callStatus === 'failed' && <span></span>}
                        {callStatus === 'hold' && <span>On hold</span>}
                        {callStatus === 'mute' && <span>On Mute</span>}

                    </div>
                </div>
                <div className="call-animation">
                    <img src={person} className="img-circle" alt="test" style={{ cursor: 'pointer' }} />
                </div>

                <div className="caller-info">

                    {/* <div> {"Harihara pandi"} </div> */}
                    <div>{ numberMask ? maskPhoneNumber(phonenumber):phonenumber}</div>
                </div>
            </div>

            <div className='webphone-bottom-container'>

                <div className='webphone-bottom-container-row1'>
                    <button onClick={toggleMute} style={{ color: '#2196F3', fontSize: '20px' }} className='webphone-icons'>
                        <FontAwesomeIcon icon={isMuted ? faMicrophoneSlash : faMicrophone} />
                        <div className="icon-label mute">Mute</div>
                    </button>

                    <button onClick={toggleHold} className='webphone-icons'>
                        <FontAwesomeIcon icon={isOnHold ? faPlay : faPause} style={{ color: '#2196F3', fontSize: '20px', }} />
                        <div className="icon-label hold">Hold</div>
                    </button>


                    <button onClick={viewlead} className='webphone-icons'>
                        <FontAwesomeIcon icon={faEye} style={{ color: '#2196F3', fontSize: '20px', }} />
                        <div className="icon-label hold">View Lead</div>
                    </button>

                    {/* 
                    <button onClick={toggleHold} className='webphone-icons'>
                        <FontAwesomeIcon icon={faPlus} style={{ color: '#2196F3', fontSize: '20px', }}  />
                        <div className="icon-label hold">Add</div>
                    </button> */}

                </div>

                <div className='webphone-bottom-container-row2'>


                    <button className='webphone-icons'>
                        <FontAwesomeIcon icon={faShareSquare} style={{ color: '#2196F3', fontSize: '20px', }} />
                        <div className="icon-label hold">Transfer</div>
                    </button>

                    <button onClick={handleHangup} className='webphone-icons'>
                        <FontAwesomeIcon icon={faPhone} style={{ color: 'red', fontSize: '25px', }} />
                        <div className="icon-label hold">Hangup</div>
                    </button>



                    <button onClick={crmviewlead} className='webphone-icons'>
                        <FontAwesomeIcon icon={faKeyboard} style={{ color: '#2196F3', fontSize: '20px', }} />
                        <div className="icon-label hold">DialPad</div>
                    </button>


                </div>



            </div>



        </div>




    )
}
export default Webphone;